module.exports = __webpack_public_path__ + "img/car.ab45c703.png";